export default async function getDateFnsLocale(locale) {
    switch (locale.toLowerCase()) {
        case "ar":
            return (await import("date-fns/locale/ar")).ar;
        case "ar-dz":
            return (await import("date-fns/locale/ar-DZ")).arDZ;
        case "ar-eg":
            return (await import("date-fns/locale/ar-EG")).arEG;
        case "ar-ma":
            return (await import("date-fns/locale/ar-MA")).arMA;
        case "ar-sa":
            return (await import("date-fns/locale/ar-SA")).arSA;
        case "ar-tn":
            return (await import("date-fns/locale/ar-TN")).arTN;
        case "az":
            return (await import("date-fns/locale/az")).az;
        case "be":
            return (await import("date-fns/locale/be")).be;
        case "be-tarask":
            return (await import("date-fns/locale/be-tarask")).beTarask;
        case "bg":
            return (await import("date-fns/locale/bg")).bg;
        case "bn":
            return (await import("date-fns/locale/bn")).bn;
        case "bs":
            return (await import("date-fns/locale/bs")).bs;
        case "ca":
            return (await import("date-fns/locale/ca")).ca;
        case "ckb":
            return (await import("date-fns/locale/ckb")).ckb;
        case "cs":
            return (await import("date-fns/locale/cs")).cs;
        case "cy":
            return (await import("date-fns/locale/cy")).cy;
        case "da":
            return (await import("date-fns/locale/da")).da;
        case "de":
            return (await import("date-fns/locale/de")).de;
        case "de-at":
            return (await import("date-fns/locale/de-AT")).deAT;
        case "el":
            return (await import("date-fns/locale/el")).el;
        case "en-au":
            return (await import("date-fns/locale/en-AU")).enAU;
        case "en-ca":
            return (await import("date-fns/locale/en-CA")).enCA;
        case "en-gb":
            return (await import("date-fns/locale/en-GB")).enGB;
        case "en-ie":
            return (await import("date-fns/locale/en-IE")).enIE;
        case "en-in":
            return (await import("date-fns/locale/en-IN")).enIN;
        case "en-nz":
            return (await import("date-fns/locale/en-NZ")).enNZ;
        case "en-us":
            return (await import("date-fns/locale/en-US")).enUS;
        case "en-za":
            return (await import("date-fns/locale/en-ZA")).enZA;
        case "eo":
            return (await import("date-fns/locale/eo")).eo;
        case "es":
            return (await import("date-fns/locale/es")).es;
        case "et":
            return (await import("date-fns/locale/et")).et;
        case "eu":
            return (await import("date-fns/locale/eu")).eu;
        case "fa-ir":
            return (await import("date-fns/locale/fa-IR")).faIR;
        case "fi":
            return (await import("date-fns/locale/fi")).fi;
        case "fr":
            return (await import("date-fns/locale/fr")).fr;
        case "fr-ca":
            return (await import("date-fns/locale/fr-CA")).frCA;
        case "fr-ch":
            return (await import("date-fns/locale/fr-CH")).frCH;
        case "fy":
            return (await import("date-fns/locale/fy")).fy;
        case "gd":
            return (await import("date-fns/locale/gd")).gd;
        case "gl":
            return (await import("date-fns/locale/gl")).gl;
        case "gu":
            return (await import("date-fns/locale/gu")).gu;
        case "he":
            return (await import("date-fns/locale/he")).he;
        case "hi":
            return (await import("date-fns/locale/hi")).hi;
        case "hr":
            return (await import("date-fns/locale/hr")).hr;
        case "ht":
            return (await import("date-fns/locale/ht")).ht;
        case "hu":
            return (await import("date-fns/locale/hu")).hu;
        case "hy":
            return (await import("date-fns/locale/hy")).hy;
        case "id":
            return (await import("date-fns/locale/id")).id;
        case "is":
            return (await import("date-fns/locale/is")).is;
        case "it":
            return (await import("date-fns/locale/it")).it;
        case "it-ch":
            return (await import("date-fns/locale/it-CH")).itCH;
        case "ja":
            return (await import("date-fns/locale/ja")).ja;
        case "ja-hira":
            return (await import("date-fns/locale/ja-Hira")).jaHira;
        case "ka":
            return (await import("date-fns/locale/ka")).ka;
        case "kk":
            return (await import("date-fns/locale/kk")).kk;
        case "km":
            return (await import("date-fns/locale/km")).km;
        case "kn":
            return (await import("date-fns/locale/kn")).kn;
        case "ko":
            return (await import("date-fns/locale/ko")).ko;
        case "lb":
            return (await import("date-fns/locale/lb")).lb;
        case "lt":
            return (await import("date-fns/locale/lt")).lt;
        case "lv":
            return (await import("date-fns/locale/lv")).lv;
        case "mk":
            return (await import("date-fns/locale/mk")).mk;
        case "mn":
            return (await import("date-fns/locale/mn")).mn;
        case "ms":
            return (await import("date-fns/locale/ms")).ms;
        case "mt":
            return (await import("date-fns/locale/mt")).mt;
        case "nb":
            return (await import("date-fns/locale/nb")).nb;
        case "nl":
            return (await import("date-fns/locale/nl")).nl;
        case "nl-be":
            return (await import("date-fns/locale/nl-BE")).nlBE;
        case "nn":
            return (await import("date-fns/locale/nn")).nn;
        case "oc":
            return (await import("date-fns/locale/oc")).oc;
        case "pl":
            return (await import("date-fns/locale/pl")).pl;
        case "pt":
            return (await import("date-fns/locale/pt")).pt;
        case "pt-br":
            return (await import("date-fns/locale/pt-BR")).ptBR;
        case "ro":
            return (await import("date-fns/locale/ro")).ro;
        case "ru":
            return (await import("date-fns/locale/ru")).ru;
        case "se":
            return (await import("date-fns/locale/se")).se;
        case "sk":
            return (await import("date-fns/locale/sk")).sk;
        case "sl":
            return (await import("date-fns/locale/sl")).sl;
        case "sq":
            return (await import("date-fns/locale/sq")).sq;
        case "sr":
            return (await import("date-fns/locale/sr")).sr;
        case "sr-latn":
            return (await import("date-fns/locale/sr-Latn")).srLatn;
        case "sv":
            return (await import("date-fns/locale/sv")).sv;
        case "ta":
            return (await import("date-fns/locale/ta")).ta;
        case "te":
            return (await import("date-fns/locale/te")).te;
        case "th":
            return (await import("date-fns/locale/th")).th;
        case "tr":
            return (await import("date-fns/locale/tr")).tr;
        case "ug":
            return (await import("date-fns/locale/ug")).ug;
        case "uk":
            return (await import("date-fns/locale/uk")).uk;
        case "uz":
            return (await import("date-fns/locale/uz")).uz;
        case "uz-cyrl":
            return (await import("date-fns/locale/uz-Cyrl")).uzCyrl;
        case "vi":
            return (await import("date-fns/locale/vi")).vi;
        case "zh-cn":
            return (await import("date-fns/locale/zh-CN")).zhCN;
        case "zh-hk":
            return (await import("date-fns/locale/zh-HK")).zhHK;
        case "zh-tw":
            return (await import("date-fns/locale/zh-TW")).zhTW;
        default:
            return (await import("date-fns/locale/en-GB")).enGB;
    }
}
